// extracted by mini-css-extract-plugin
export default {"sticky":"SalesPlanProductTable_sticky__Gm8Qt","header":"SalesPlanProductTable_header__-EAf-"};